import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

import Post from "./Post";
import Header from "./Header";
import LeftCard from "./LeftCard";
import Footer from "./Footer";
import {
	Button,
	Alert,
	Card,
	CardImg,
	CardBody,
	CardTitle,
	CardSubtitle,
	CardText,
} from "react-bootstrap";


const ComingSoon = () => (
	<Fragment>
		<Header />
        
		<main className="my-5 py-5">
			<Container className="px-0">
            
				<Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					<Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					>
                    <Fragment>
	
                    {/* <Card>
        <div className="video-responsive position-relative">
		<img
										src='./sethu-ai.png'
										alt="avatar"
										
										style={{

											width:"auto",
        height:"335",
										}}
									/>
			</div>
        </Card> */}
        </Fragment>
					</Col>

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					>
					 <Fragment>
                     <div className="position-relative">
                     <article
							
						>
							<p>Coming Soon ...</p>

					</article>
                        </div>

		
        </Fragment>
					</Col>
				</Row>


             




			</Container>
		</main><Footer />
	</Fragment>
);

export default ComingSoon;
